import { render, staticRenderFns } from "./VPSForgotUserIdSelect.vue?vue&type=template&id=f001d3d4&scoped=true"
import script from "./VPSForgotUserIdSelect.vue?vue&type=script&lang=js"
export * from "./VPSForgotUserIdSelect.vue?vue&type=script&lang=js"
import style0 from "./VPSForgotUserIdSelect.vue?vue&type=style&index=0&id=f001d3d4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f001d3d4",
  null
  
)

export default component.exports